import { startApp } from './boot';

const root = document.getElementById('root');
if (!root) throw new Error('#root element is missing');
startApp(root);
